import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import styles from './UOAStyles.js';
import { auth } from '../../fire';
import { is_weekend } from '../../components/Modals/UOAModal/getDate';
import { zoomPercentUOABoard } from './zoomFunction';
import { connect } from 'react-redux';
import ActionTypes from '../../actions/types';
import { setFilterUOA, UOAEarning, UOAETATIME } from './utils';
import UOAVideoModal from './components/tables/UOAVideoModel.jsx';
import { meta } from './components/tables/data.js';
import UOAWebView from './components/tables/UOAWebView.jsx';
import UOAMobileView from './components/tables/UOAMobileView.js';

class UnusualOptionsActivity extends Component {
  constructor(props) {
    super(props);

    this.uoaEndRef = React.createRef();
    this.width = props.width;
    this.isMobile = this.width < 850;
  }

  moveToLeft = () =>
    this.uoaEndRef.current.scrollIntoView({
      behavior: 'smooth',
    });

  componentDidMount() {
    this.props.loginCheck();
    const newDate =
      this.props.appState.accessLevel === 'fullaccess'
        ? is_weekend(this.props.state.date)
        : this.props.state.date;
    this.props.setStateAction({ date: newDate });
    localStorage.setItem('Date', this.props.state.date);
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.loadUOAData();
      }
    });

    if (!this.isMobile) {
    }
  }
  componentDidUpdate(prevProps) {
    const { onPlay } = this.props.appState;
    if (!prevProps.onPlay && onPlay) {
      this.props.setStateAction({ showVideo: true });
    }
    if (prevProps.onPlay && !onPlay) {
      this.props.setStateAction({ showVideo: false });
    }
    if (!this.isMobile) {
      // this.moveToLeft();
    }
  }

  loadUOAData = async () => {
    const now = new Date();
    const nowTxt = moment().tz('America/New_York').format('HH:mm');
    if (nowTxt >= '09:00' && nowTxt <= '09:50') {
      const currentMin = now.getMinutes();
      const nextMin = 50 - (currentMin % 50);

      const nextRefresh = moment(now, 'hh:mm')
        .add(nextMin, 'minutes')
        .format('hh:mm');
      this.props.setStateAction({
        nextRefreshTime: nextRefresh,
        refreshUOA: false,
      });

      setTimeout(() => {
        this.loadUOAData();
      }, nextMin * 60 * 1000);
    } else {
      const response = await UOAETATIME();
      this.props.setStateAction({
        nextRefreshTime: response.nextRefresh,
        time: nowTxt,
        localUOA: response.newData,
        fullUOA: response.newData,
      });

      setTimeout(() => {
        const localDate = localStorage.getItem('Date');
        const newDate = moment().format('YYYY-MM-DD');
        if (new Date(localDate) >= newDate) {
          this.props.setStateAction({ check: true });
          this.loadUOAData();
        }
      }, response.nextMin * 60 * 1000);
    }

    this.setFilters();
  };

  getEarning = async (Data) => {
    await UOAEarning(Data);
    this.props.setStateAction({ localUOA: Data, fullUOA: Data });
    this.setFilters();
  };

  sortData = (type) => {
    this.props.setStateAction({ orderBy: type });
    const { orderBy, order } = this.props.state;
    const isAsc = orderBy === type && order === 'asc';
    this.props.setStateAction({ order: isAsc ? 'desc' : 'asc', page: 1 });
  };

  setFilters = async (caseString) => {
    await this.props.setUOAFilter(caseString);
    var {
      stockFilter,
      etfFilter,
      smallFilter,
      midFilter,
      largeFilter,
      IVUP,
      IVDOWN,
    } = this.props.state;

    const { fullUOA } = this.props.state;
    const localUOA = await setFilterUOA(
      fullUOA,
      stockFilter,
      etfFilter,
      smallFilter,
      midFilter,
      largeFilter,
      IVUP,
      IVDOWN
    );

    this.props.setStateAction({ localUOA, page: 1 });
  };

  getFilters = (caseString) => {
    const filters = {
      all1: !this.props.state.stockFilter && !this.props.state.etfFilter,
      stock: this.props.state.stockFilter,
      etf: this.props.state.etfFilter,
      all2:
        !this.props.state.smallFilter &&
        !this.props.state.midFilter &&
        !this.props.state.largeFilter,
      Small: this.props.state.smallFilter,
      Mid: this.props.state.midFilter,
      Large: this.props.state.largeFilter,
      all3: !this.props.state.IVUP && !this.props.state.IVDOWN,
      IVUP: this.props.state.IVUP,
      IVDOWN: this.props.state.IVDOWN,
    };
    return filters[caseString];
  };
  handleCloseVideo = () => {
    this.props.setStateAction({ showVideo: false, onPlay: false });
  };
  render() {
    const { articles, width, errorUoa } = this.props.appState;
    const { showLoader, isdata } = this.props.state;
    const isMobile = width < 850;

    let zoom = zoomPercentUOABoard(window.innerWidth);
    let optionColSpam = 8;
    let StocksColSpam = 7;
    if (window.innerWidth <= 1500) {
      optionColSpam = 9;
      StocksColSpam = 6;
    }
    if (!isMobile)
      return (
        <DocumentMeta {...meta}>
          <div
            style={{
              ...styles.mainContainer,
              margin: window.innerWidth > 2000 ? 'auto' : '',
              width: window.innerWidth > 2000 ? '2000px' : '',
            }}>
            <UOAVideoModal
              styles={styles}
              onPlay={this.props.appState.onPlay}
              handleCloseVideo={this.handleCloseVideo}
            />

            <UOAWebView
              errorUoa={errorUoa}
              zoom={zoom}
              styles={styles}
              setFilters={(data) => this.setFilters(data)}
              getFilters={(data) => this.getFilters(data)}
              showLoader={showLoader}
              isdata={isdata}
              StocksColSpam={StocksColSpam}
              optionColSpam={optionColSpam}
              setStateAction={(data) => this.props.setStateAction(data)}
              state={this.props.state}
              loadUOAData={this.loadUOAData}
              accessLevel={this.props.appState.accessLevel}
              orderBy={this.props.state.orderBy}
              order={this.props.state.order}
              sortData={this.sortData}
              uoaEndRef={this.uoaEndRef}
              isMobile={isMobile}
              articles={articles}
            />
          </div>
        </DocumentMeta>
      );
    return (
      <div>
        <UOAMobileView
          accessLevel={this.props.appState.accessLevel}
          styles={styles}
          setFilters={(data) => this.setFilters(data)}
          getFilters={(data) => this.getFilters(data)}
          setStateAction={(data) => this.props.setStateAction(data)}
          orderBy={this.props.state.orderBy}
          order={this.props.state.order}
          loadUOAData={this.loadUOAData}
          isMobile={isMobile}
          sortData={this.sortData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state: state.UOAState,
  appState: state.appReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_UOA_STATE,
      payload: newState,
    }),
  setUOAFilter: (newState) =>
    dispatch({
      type: ActionTypes.SET_UOA_FILTER,
      payload: newState,
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UnusualOptionsActivity));



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/index.js